//项目里面所有的页面组件的绝对地址
export default {
  Layout: 'layout/Layout',
  EmptyPage: 'common/emptyPage',
  //订单模块一些页面
  InspectionOrder: 'order/inspectionOrder',
  InspectionOrderDetail: 'order/inspectionOrderDetail',
  ProjectOrder: 'order/projectOrder',
  ProjectOrderDetail: 'order/projectOrderDetail',
  EngineeringOrder: 'order/engineering/index',//工程单新
  EngineeringOrderDetail: 'order/engineering/detail',
  RepairOrder: 'order/repairOrder',
  WarningOrder: 'order/warningOrder',
  RepairDetail: 'order/repairOrderDetail',
  ItemOrder: 'order/itemOrder',
  ItemOrderDetail: 'order/itemOrderDetail',
  OrderCreate: 'order/orderCreate',
  RepairCreate: 'order/repairCreate',
  ProjectCreate: 'order/projectCreate',
  InspectionCreate: 'order/inspectionCreate',
  ItemCreate: 'order/itemCreate',
  EngineeringCreate: 'order/engineering/create',


  ChangeFeeAudit: 'projectAudit/changeFeeAudit',
  Personnel: 'system/personnel',
  Role: 'system/role',
  ServiceStation: 'system/serviceStation',
  Enterprise: 'system/enterprise',
  // TODO
  ItemTypeManage: 'system/itemTypeManage/index',
  ConfigManage: 'system/configManage/index',
  ProjectTypeManage: 'system/projectTypeManage/index',
  Engineer: 'resource/engineer',
  ResourceClient: 'resource/client',
  ClientContact: 'resource/clientContact',
  OutsourceRecord: 'resource/outsourceRecord',
  EmployeeList: 'resource/employeeList',
  EmployeeAddEdit: 'resource/employeeAddEdit',
  PersonOutsourceAddEdit: 'resource/personOutsourceAddEdit',
  ClientOutsourceAddEdit: 'resource/clientOutsourceAddEdit',
  ClientOutsourceDetail: 'resource/clientOutsourceDetail',
  PersonnelOutsourceDetail: 'resource/personnelOutsourceDetail',

  ContractList: 'contract/contractList',
  ContractCreate: 'contract/contractCreate',
  ContractDetail: 'contract/contractDetail',
  ProjectProcess: 'process/projectProcess',
  ProjectSOP: 'process/projectSOP',

  ProviderArchiveList: 'archive/providerArchiveList',
  EngineerArchiveList: 'archive/engineerArchiveList',
  EngineerApproveList: 'archive/engineerApproveList',
  EngineerDetail: 'resource/engineerDetail',
  BankClientList: 'resource/bankClientList',

  ///************项目管理************
  //项目管理-工程项目
  EngineeringProjectManage: 'engineeringSetting/engineeringProjectManage/index',
  EngineeringProjectCreate: 'engineeringSetting/engineeringProjectManage/engineeringCreate',
  EngineeringProjectDetail: 'engineeringSetting/engineeringProjectManage/engineeringDetail',
  EngineeringAudit: 'engineeringSetting/engineeringProjectManage/auditDialog/index',
  EngineeringApprove: 'engineeringSetting/engineeringProjectManage/auditDialog/index',


  //项目管理-巡检项目
  MonitorProcess: 'engineeringSetting/monitorProcess/monitorProcess',
  MonitorDetail: 'engineeringSetting/monitorProcess/monitorDetail',
  MonitorTaskDetail: 'engineeringSetting/monitorProcess/monitorTaskDetail',
  MonitorTemplate: 'engineeringSetting/monitorProcess/monitorTemplate',
  ServicePlanManage: 'engineeringSetting/monitorProcess/servicePlanManage',
  MonitorContentSetting: 'engineeringSetting/monitorProcess/monitorContentSetting',


  // 统计分析
  WorkOrder: 'analyse/workOrder/index',
  Performancesta: 'analyse/performancesta/index',
  AreaPersonBusy: 'analyse/workOrder/areaPersonBusy',
  AreaBusy: 'analyse/workOrder/areaBusy',
  AllPersonBusy: 'analyse/workOrder/allPersonBusy',
  QutletsOrder: 'analyse/workOrder/qutletsOrder',

  //系统设置
  Equipment: 'system/equipment/index',//系统设置-辅助器材库
  Timeliness: 'system/timeliness/index',//系统设置-时效设置
}

export const PathKeys = {
  Layout: 'Layout',
  EmptyPage: 'EmptyPage',
  InspectionOrder: 'InspectionOrder',
  InspectionOrderDetail: 'InspectionOrderDetail',
  ProjectOrder: 'ProjectOrder',
  ProjectOrderDetail: 'ProjectOrderDetail',
  EngineeringOrder: 'EngineeringOrder',//工程单新
  EngineeringOrderDetail: 'EngineeringOrderDetail',
  RepairOrder: 'RepairOrder',
  WarningOrder: 'WarningOrder',
  RepairDetail: 'RepairDetail',
  ItemOrder: 'ItemOrder',
  ItemOrderDetail: 'ItemOrderDetail',
  OrderCreate: 'OrderCreate',
  RepairCreate: 'RepairCreate',
  ProjectCreate: 'ProjectCreate',
  EngineeringCreate: 'EngineeringCreate',//工程单新

  InspectionCreate: 'InspectionCreate',
  ItemCreate: 'ItemCreate',

  ChangeFeeAudit: 'ChangeFeeAudit',
  Personnel: 'Personnel',
  Role: 'Role',
  ServiceStation: 'ServiceStation',
  Enterprise: 'Enterprise',
  ItemTypeManage: 'ItemTypeManage',
  ConfigManage: 'ConfigManage',
  ProjectTypeManage: 'ProjectTypeManage',
  Engineer: 'Engineer',
  ResourceClient: 'ResourceClient',
  ClientContact: 'ClientContact',
  OutsourceRecord: 'OutsourceRecord',
  EmployeeList: 'EmployeeList',
  EmployeeAddEdit: 'EmployeeAddEdit',
  PersonOutsourceAddEdit: 'PersonOutsourceAddEdit',
  ClientOutsourceAddEdit: 'ClientOutsourceAddEdit',
  ClientOutsourceDetail: 'ClientOutsourceDetail',
  PersonnelOutsourceDetail: 'PersonnelOutsourceDetail',

  ContractList: 'ContractList',
  ContractCreate: 'ContractCreate',
  ContractDetail: 'ContractDetail',
  ProjectProcess: 'ProjectProcess',
  ProjectSOP: 'ProjectSOP',
  MonitorTemplate: 'MonitorTemplate',

  ProviderArchiveList: 'ProviderArchiveList',
  EngineerArchiveList: 'EngineerArchiveList',
  EngineerApproveList: 'EngineerApproveList',
  EngineerDetail: 'EngineerDetail',
  BankClientList: 'BankClientList',

  EngineeringProjectManage: 'EngineeringProjectManage',
  EngineeringProjectCreate: 'EngineeringProjectCreate',
  EngineeringProjectDetail: 'EngineeringProjectDetail',
  EngineeringAudit: 'EngineeringAudit',
  EngineeringApprove: 'EngineeringApprove',
  MonitorProcess: 'MonitorProcess',
  MonitorDetail: 'MonitorDetail',
  MonitorTaskDetail: 'MonitorTaskDetail',
  ServicePlanManage: 'ServicePlanManage',
  MonitorContentSetting: 'MonitorContentSetting',

  // 统计分析
  WorkOrder: 'WorkOrder',
  Performancesta: 'Performancesta',
  AreaPersonBusy: 'AreaPersonBusy',
  AreaBusy: 'AreaBusy',
  AllPersonBusy: 'AllPersonBusy',
  QutletsOrder: 'QutletsOrder',

  //系统设置
  Equipment: 'Equipment',
  Timeliness: 'Timeliness'
}



// WEBPACK FOOTER //
// ./src/config/componentList.js